// Component for pie chart using AgChartsReac
import React from "react";
import { AgChartsReact } from "ag-charts-react";
import { getKpiValueWithFormatting } from "../../utils/kpiUtils";
import { KpiSpec } from "../../models/kpis";

interface Props {
  categories: any[];
  data: DonutChartData[];
  kpiSpec: KpiSpec;
}

export interface DonutChartData {
  category: string;
  amount: number;
}

function getTooltipContent(
  params: any,
  formatting: string,
  totalOfAllCategories: number,
) {
  const firstPart = getKpiValueWithFormatting(
    formatting,
    params.datum["amount"],
  );
  const secondPart = (params.datum["amount"] / totalOfAllCategories) * 100;
  return firstPart + ` (${secondPart.toFixed(2)}%)`;
}

function getInnerLabels(
  totalOfAllCategories: number,
  averageOfAllCategories: number,
  kpiSpec: KpiSpec,
) {
  const total = [
    {
      text: getKpiValueWithFormatting(kpiSpec.formatting, totalOfAllCategories),
      fontSize: 23,
      fontWeight: "bold",
      color: "black",
      margin: 10,
    },
    {
      text: "Total",
      fontSize: 14,
      color: "black",
      fontWeight: "600",
      margin: 2,
    },
  ];

  const average = [
    {
      text: getKpiValueWithFormatting(
        kpiSpec.formatting,
        averageOfAllCategories,
      ),
      fontSize: 23,
      fontWeight: "bold",
      color: "black",
      margin: 10,
    },
    {
      text: "Average",
      fontSize: 14,
      color: "black",
      fontWeight: "600",
      margin: 2,
    },
  ];

  if (kpiSpec.chartTypes.includes("donutChartWithTotalAndAverage")) {
    return [...total, ...average];
  }

  if (kpiSpec.chartTypes.includes("donutChartWithTotal")) {
    return total;
  }

  if (kpiSpec.chartTypes.includes("donutChartWithAverage")) {
    return average;
  }

  return [];
}

export default function KpiDonutChart({ categories, data, kpiSpec }: Props) {
  const totalOfAllCategories = data.reduce((acc, curr) => acc + curr.amount, 0);
  const averageOfAllCategories = totalOfAllCategories / data.length;
  return (
    <div className="col max-h-[500px]">
      <div className="flex flex-row items-start justify-center pb-2">
        <div className="flex flex-col items-center px-4">
          <div className="text-xl font-medium">{kpiSpec.header}</div>
          <div className="text-gray-500">{kpiSpec.subheader}</div>
        </div>
      </div>
      <AgChartsReact
        options={{
          // title: {
          //   text: title,
          // },
          // subtitle: {
          //   text: subTitle,
          // },
          data: data,
          series: [
            {
              type: "donut",
              // calloutLabelKey: "amount",
              angleKey: "amount",
              legendItemKey: "category",
              innerRadiusRatio: 0.75,
              innerCircle: {
                fill: "lightgreen",
              },
              innerLabels: getInnerLabels(
                totalOfAllCategories,
                averageOfAllCategories,
                kpiSpec,
              ) as any,
              tooltip: {
                renderer(params) {
                  return {
                    content: getTooltipContent(
                      params,
                      kpiSpec.formatting,
                      totalOfAllCategories,
                    ),
                  };
                },
              },
            },
          ],
        }}
      />
    </div>
  );
}
